import { render } from "./SocialLink.vue?vue&type=template&id=21b051b0&scoped=true"
import script from "./SocialLink.vue?vue&type=script&lang=js"
export * from "./SocialLink.vue?vue&type=script&lang=js"

import "./SocialLink.vue?vue&type=style&index=0&id=21b051b0&scoped=true&lang=scss"

import exportComponent from "/Users/konatsu/docker-static/speedo.devs/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-21b051b0"]])

export default __exports__